/** True when CMS supplied a non-empty URL string (trimmed). */
export default function hasNavigableHref(href: string | null | undefined): boolean {
    return typeof href === 'string' && href.trim().length > 0;
}
